import React from 'react';
import RowBuilder, { RowBuilderProps } from '../RowBuilder';
import { PasswordHelpers } from 'components/Common/Formik/PasswordHelpers/PasswordHelpers';
import { Field } from 'types/Field';

type Props = RowBuilderProps;

export default function RowRepeatedPassword({
  field,
  styles,
}: Props): JSX.Element {
  const {
    type, // eslint-disable-line @typescript-eslint/no-unused-vars -- Extracted for non-reuse.
    repeatedType,
    secondName,
    secondLabel,
    secondId,
    secondPlaceholder,
    ...commonProps
  } = field as Extract<Field, { type: 'repeated' }>;

  const firstFieldProps = {
    ...commonProps,
    type: repeatedType,
  };

  const secondFieldProps = {
    ...commonProps,
    type: repeatedType,
    name: secondName,
    label: secondLabel,
    id: secondId,
    placeholder: secondPlaceholder,
  };

  return (
    <>
      <RowBuilder styles={styles} field={firstFieldProps} />
      <PasswordHelpers name={field.name} />
      <RowBuilder styles={styles} field={secondFieldProps} />
    </>
  );
}
